import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { TopPeerHoldersModel } from './top-peer-holders.model';

export class TopPeerHoldersConfiguration extends ReportSectionConfigurationBase {
  typeName = 'TopPeerHoldersConfiguration';
  nodataLocalizationKeyName = 'topPeerHolders';
  readonly reportSection = ReportSection.TopPeerHolders;
  readonly applicableReportTypes = [ReportType.OwnershipAnalyticsReport];
  readonly reportViewModelSections = [ReportViewModelSection.OwnershipAnalyticsReport_TopPeerHolders];
  readonly minSize = 2;
  readonly maxSize = 4;
  readonly defaultSize = 2;
  readonly availableDataSections = [];

  get name(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'topPeerHolders';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'Top Peer Holders';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface TopPeerHoldersData {
  [ReportViewModelSection.OwnershipAnalyticsReport_TopPeerHolders]: TopPeerHoldersModel;
}
